import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Shown wherever a chat composer would otherwise sit. The server supplies only
// a fixed reason code, and this local map chooses the trusted copy instead of
// rendering a network-supplied message into the status element.
//
// There is deliberately no retry button: nothing to retry until the Responses
// migration (prg-dqk) lands.
const FALLBACK_MESSAGE = 'Chat is temporarily unavailable. Please try again shortly.';
const CHAT_UNAVAILABLE_MESSAGES = Object.freeze({
  chat_vendor_unavailable: 'Chat is temporarily unavailable. Your daily digest and email triage are still running as normal.',
  chat_storage_unavailable: 'Chat is temporarily unavailable because storage is unavailable. Please try again shortly.',
  chat_auth_expired: 'Your chat session has expired. Sign in again to continue.',
  chat_conversation_unresolvable: 'This conversation cannot be continued. Your next message starts a new conversation.',
});

export default function ChatUnavailableNotice({ reason, className = '' }) {
  const message = CHAT_UNAVAILABLE_MESSAGES[reason] || FALLBACK_MESSAGE;

  return (
    <div
      role="status"
      data-testid="chat-unavailable-notice"
      className={`flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900 ${className}`}
    >
      <AlertTriangle size={16} className="mt-0.5 shrink-0" />
      <p className="m-0">
        <span className="font-semibold">{message}</span>
      </p>
    </div>
  );
}
